import { useTranslation } from 'react-i18next'
import { invalidateCertificateCache, useAddCertificate } from '../../../../api/Certificates'
import { CreateCertificateForm } from '../../../../forms/certificate-forms/CreateCertificateForm'
import { ShowDialogProps } from '../../../../show-dialog'
import { invalidateMainComponentCache } from '../../../../api/main-component'
import { validateCertificateResponse } from '../../../../utils'
import { invalidationActivityLogCache } from 'src/api/activity-log'
import { useParams } from 'react-router-dom'
import { invalidateLocalityCache } from 'src/api/localities'

interface CreateCertificateDialogProps extends ShowDialogProps {
  mainComponentId: EntityId
  customerId: EntityId
}

export const CreateCertificateDialog: React.FC<CreateCertificateDialogProps> = ({
  pop,
  mainComponentId,
  customerId,
}) => {
  const { localityId } = useParams()
  const { t } = useTranslation(['certificate', 'common'])
  const mutation = useAddCertificate(mainComponentId)

  const onSubmit = async (form, formContext?) => {
    form.validPeriod = form.validPeriod?.id
    mutation.mutateAsync(form, {
      onSuccess: () => {
        invalidateCertificateCache.getCertificates(mainComponentId)
        invalidateMainComponentCache.getMainComponentById(customerId, mainComponentId)
        invalidationActivityLogCache.getCageActivityLogs()
        invalidateLocalityCache.getCageStatus(customerId, localityId)
        pop()
      },
      onError: error => {
        if (error?.['data'] == 'CannotAddCertificate') {
          if (formContext && typeof formContext.setError === 'function') {
            formContext.setError('certificateNumber', {
              type: 'manual',
              message: t('certificateNumberExists', { ns: 'main-component' }),
            })
          }
        }
        validateCertificateResponse(error?.['data'])
      },
    })
  }

  return (
    <CreateCertificateForm
      onSubmit={onSubmit}
      onCancel={pop}
      customerId={customerId}
      title={t('addNewCertificate', { ns: 'certificate' })}
    />
  )
}
